import React, { useEffect, useState } from 'react';
import MobileFrame from '../components/MobileFrame';

const NotFound: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    sessionStorage.removeItem('token');
  }, []);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const content = (
    <div className="flex flex-col items-center justify-center h-full bg-gray-50 dark:bg-dark p-4 text-center">
      {/* Error Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-20 w-20 text-red-600 mb-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v4m0 4h.01M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
        />
      </svg>

      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
        Something went wrong
      </h1>

      <p className="text-lg text-gray-700 dark:text-dark-secondary mb-6 max-w-md">
        Unable to process your request. Please try generating the link again.
      </p>
    </div>
  );

  return isMobile ? (
    <div className="h-[100dvh] w-full p-5 overflow-hidden bg-white dark:bg-dark">
      {content}
    </div>
  ) : (
    <MobileFrame >
      {content}
    </MobileFrame>
  );
};

export default NotFound;